import { withDevtools, withRedux } from '@angular-architects/ngrx-toolkit';
import { signalStore, withState } from '@ngrx/signals';
import { CompanyStoreState, COMPANY_STORE_INITIAL_STATE } from './company.state';
import { companyActions as actions } from './company.action';
import { companyReducer as reducer } from './company.reducer';
import { companyEffects as effects } from './company.effect';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class CompanyStore extends signalStore(
    withState<CompanyStoreState>(COMPANY_STORE_INITIAL_STATE),
    withDevtools('RCP Company Store'),
    withRedux({
        actions,
        reducer,
        effects,
    }),
) {}
